import styled from 'styled-components';


import { useCustomTheme, Palette } from '../../styles';

type RootProps = {
	color?: 'black' | 'primary' | 'muted';
	noHover?: boolean;
}

const getColor = (palette: Palette, colorName: string) => {
	const map = {
		'black': palette.blackPrimary,
		'primary': palette.accentPrimary,
		'muted': palette.blackSecondary,
	};

	return map[colorName];
};

const Root = styled.a<RootProps>`
	transition: color .2s ease-in-out;
	cursor: pointer;
	text-decoration: none;
	display: inline-flex;

	${p => p.color && `
		color: ${getColor(useCustomTheme(p)[0].color, p.color)};
	`}

	${p => !p.noHover && `
		&:hover {
			color: ${useCustomTheme(p)[0].color.accentPrimaryHover};
			text-decoration: underline;
		}
	`}
`;

export {
	Root
}